// Job Board data for displaying companies and their job opportunities
import ccsLogo from '@/data/2026/assets/images/job-board/ccs-logo.webp'
import dteLogo from '@/data/2026/assets/images/job-board/dte-logo.webp'
import grandCircusLogo from '@/data/2026/assets/images/job-board/grand-circus-logo.webp'
import compassLogo from '@/data/2026/assets/images/job-board/compass-logo.webp'
import googleLogo from '@/data/2026/assets/images/job-board/google-logo.webp'
import ibmLogo from '@/assets/images/sponsors/IBM_logo.webp'

export const jobBoardData = [
  {
    id: 1,
    name: 'College for Creative Studies',
    logo: ccsLogo,
    website: 'https://bit.ly/ccs-jobs-25',
  },
  {
    id: 2,
    name: 'DTE Energy',
    logo: dteLogo,
    website: 'https://bit.ly/dte-jobs-25',
  },
  {
    id: 3,
    name: 'Google',
    logo: googleLogo,
    website: 'https://bit.ly/google-jobs-25',
  },
  {
    id: 4,
    name: 'Grand Circus',
    logo: grandCircusLogo,
    website: 'https://bit.ly/grandcircus-jobs-25',
  },
  {
    id: 5,
    name: 'IBM',
    logo: ibmLogo,
    website: 'https://bit.ly/ibm-jobs-25',
  },
  {
    id: 6,
    name: 'Resume Drop',
    logo: compassLogo,
    website: 'https://bit.ly/compass2026-resume-drop',
  },
]
